module.exports = __webpack_public_path__ + "media/operational-planning_en_ipad_air.b9edf3bc.mp4";